<template>
  <div>
    <div id="paybylink">
      <h3>Pay by Link</h3>
      <b-card>
        <b-row>
          <b-col>
            <validation-observer ref="simpleRules">
              <form
                ref="form"
                @submit.stop.prevent="validationEditForm"
              >
                <b-row>
                  <b-col md="5">
                    <b-form-group
                      label="First Name"
                      label-for="firstName"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="firstName"
                        rules="required"
                      >
                        <b-form-input
                        v-on:paste ="(e)=>{
                          e.preventDefault() 
                          return false; }"
                        v-on:keypress="isLetter($event)"
                         id="editname-input"
                          v-model="requetFormData.firstName"
                          :state="errors.length > 0 ? false:null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="5">
                    <b-form-group
                      label="Last Name"
                      label-for="lastName"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="lastName"
                        rules="required"
                      >
                        <b-form-input
                        v-on:paste ="(e)=>{
                          e.preventDefault() 
                          return false; }"
                        v-on:keypress="isLetter($event)"
                          id="lastName-input"
                          v-model="requetFormData.lastName"
                          :state="errors.length > 0 ? false:null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="5">
                    <b-form-group
                      label="Email"
                      label-for="email"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="email"
                        rules="required"
                      >
                        <b-form-input
                          id="email-input"
                          v-model="requetFormData.email"
                          :state="errors.length > 0 ? false:null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="5">
                    <b-form-group
                      label="Phone Number"
                      label-for="phone"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="phone"
                        rules="required"
                      >
                        <b-form-input
                          id="phone-input"
                          v-model="requetFormData.phone"
                          :state="errors.length > 0 ? false:null"
                          type="number"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="5">
                    <b-form-group
                      label="Amount"
                      label-for="amount"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="amount"
                        rules="required"
                      >
                        <b-form-input
                          id="amount-input"
                          v-model.number="requetFormData.amount"
                          :state="errors.length > 0 ? false:null"
                          type="number"
                        />
                        
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="5">
                    <b-form-group
                      label="Country"
                      label-for="country"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="country"
                        rules="required"
                      >
                        <b-form-select
                          id="country-input"
                          v-model="requetFormData.country"
                          :options="countryOptions"
                          :state="errors.length > 0 ? false:null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="5">
                    <b-form-group
                      label="Currency"
                      label-for="currency"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="currency"
                        rules="required"
                      >
                        <b-form-select
                          id="currency-input"
                          v-model="requetFormData.currency"
                          :options="currencyOptions"
                          :state="errors.length > 0 ? false:null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="5">
                    <b-form-group
                      label="City"
                      label-for="city"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="city"
                        rules="required"
                      >
                        <b-form-input
                        v-on:paste ="(e)=>{
                          e.preventDefault() 
                          return false; }"
                        v-on:keypress="isLetter($event)"
                          id="city-input"
                          v-model="requetFormData.city"
                          :state="errors.length > 0 ? false:null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-col md="5">
                  <b-button
                    variant="primary"
                    type="submit"
                    @click.prevent="validationForm"
                  >
                    Send Payment Link
                  </b-button>
                </b-col>
              </form>
            </validation-observer>
          </b-col>
        </b-row>
      </b-card>
    </div>

    <div v-if="toogle">
      <h3> link has been sent to customer </h3>
    </div>
    <b-overlay
      :show="isLoading"
      no-wrap
      rounded="sm"
    />
  </div>
</template>

<script>
import {
  BCard,
  BButton,
  BOverlay,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BFormSelect,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import axios from '@axios'

export default {
  name: 'Users',
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
    BOverlay,
    BFormGroup,
    BFormInput,
    ValidationProvider,
    ValidationObserver,
    BFormSelect,
  },
  data() {
    return {
      required,
      isLoading: false,
      toogle: false,
      requetFormData: {
        firstName: '', lastName: '', email: '', phone: '', amount: '', currency: null, country: null, city: '',
      },

      currencyOptions: [
        { value: 'ETB', text: 'ETB' },
      ],
      countryOptions: [
        { value: 'ET', text: 'ET' },
      ],
      paymentOptions: [],
      statusCheck: 'false',
      userData: [],
    }
  },

  computed: {
  },
  created() {
    this.requetFormData.currency = this.currencyOptions[0].value
    this.requetFormData.country = this.countryOptions[0].value
    this.fetchData()
  },
  methods: {
    isLetter(e) {
  let char = String.fromCharCode(e.keyCode); // Get the character
  if( (/^[a-zA-Z\s]*$/).test(char)) return true; // Match with regex 
  else e.preventDefault(); // If not match, don't add to input text
    },
    fetchData() {

    },
    PayByLink() {
      // eslint-disable-next-line no-alert
      alert(`submitted!${this.statusCheck}`)
    },
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          // eslint-disable-next-line no-alert
          //  alert(`form submitted! etFormData}${this.requetFormData.paymentOptionsId}`)
          this.isLoading = true
          this.$store.dispatch('config/getActionPrivilege', 'Order-View')
          axios
            .post('/Order/api/V1.0/Orders/PayByLink', this.requetFormData)
            .then(res => {
              this.isLoading = false
              this.$bvModal.msgBoxOk(`${res.message}`, {
                title: 'Success',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'success',
                headerClass: 'p-2 border-bottom-0',
                footerClass: 'p-2 border-top-0',
                centered: true,
              })
              this.toogle = true
              document.getElementById('paybylink').innerHTML = ''
              // this.$router.push({ name: 'payment-paylink' })
            })
            .catch(res => {
              console.log(res)
              this.isLoading = false
              this.$bvModal.msgBoxOk(res.data.message, {
                title: 'Error',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'success',
                headerClass: 'p-2 border-bottom-0',
                footerClass: 'p-2 border-top-0',
                centered: true,
              })
            })

          // eslint-disable-next-line
          //alert('form submitted! '+this.requetFormData.firstName +' '+this.requetFormData.lastName+''+this.requetFormData.country+''+this.requetFormData.city+''+this.requetFormData.amount+''+this.requetFormData.paymentOptionsId+''+this.requetFormData.currency+''+this.requetFormData.phone)
        }
      })
    },
  },
}
</script>
